import {createSlice} from '@reduxjs/toolkit';
import {searchApprovalRequestsFailure, searchApprovalRequestsRequest, searchApprovalRequestsSuccess} from 'src/openapi/admin/apis/RequestSearchApi';
import {ApprovalRequestSearchItem} from 'src/openapi/admin/models/ApprovalRequestSearchItem';

import type {AppState} from 'src/store';

type InitialState = {
    requests: Array<ApprovalRequestSearchItem>,
    totalResults: number,
    isLoading: boolean,
};

export const initialState: InitialState = {
    requests: [],
    totalResults: 0,
    isLoading: false,
};

export const requestsSlice = createSlice({
    name: 'vendorAdmin/requests',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(searchApprovalRequestsRequest, state => {
            state.isLoading = true;
        });
        builder.addCase(searchApprovalRequestsSuccess, (state, action) => {
            state.requests = action.payload.data?.approvalRequests || [];
            state.totalResults = action.payload.data?.totalResults || 0;
            state.isLoading = false;
        });
        builder.addCase(searchApprovalRequestsFailure, state => {
            state.isLoading = false;
        });
    },
});

export const selectRequests = (state: AppState) => state.requestsReducer.requests;
export const selectRequestsTotalResults = (state: AppState) => state.requestsReducer.totalResults;
export const selectIsLoadingRequests = (state: AppState) => state.requestsReducer.isLoading;
